<div class="not_found__container">
	<div class="not_found__heading">
		<!-- <app-illustration type="waiter" width="300" height="300"></app-illustration> -->
		<h1 class="paragraph-color">{{'notFound.title' | translate}}</h1>
	</div>
</div>

<app-bottom-nav>
	<tg-link
		class="menu-item__back-button"
		icon="back"
		iconPosition="left"
		color="var(--primary-color)"
		text="{{'back' | translate}}"
		type="button"
		(click)="goBack()"
		customStyles="{{'border-color:  var(--border-color); border-radius: var(--rounded-tagme-buttons); font-size: var(--font-size-sm); line-height: var(--line-height-sm);' }}"
	></tg-link>
</app-bottom-nav>
